var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIconVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#528af3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1838"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.06,
    y: 2.06,
    width: 115.87,
    height: 115.87,
    rx: 21.07,
    ry: 21.07
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_893"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.83,86.33c-.43,0-.87-.11-1.26-.32-.84-.46-1.37-1.35-1.37-2.31V36.3c0-.96,.53-1.85,1.37-2.31,.85-.46,1.88-.43,2.69,.1l36.87,23.7c.75,.48,1.21,1.32,1.21,2.21s-.46,1.73-1.21,2.21l-36.87,23.7c-.43,.28-.93,.42-1.42,.42Zm2.63-45.21v37.75l29.36-18.88-29.36-18.88Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconVideo);
export default __webpack_public_path__ + "static/media/media-icon-video.2792c325707adb4f79fc8481034b41c1.svg";
export { ForwardRef as ReactComponent };